import React, { ReactElement } from 'react';

import classNames from 'classnames';

import { EvTitle, EvTooltip, HeadingLevelRange } from '@evinced-private/ui-common';

import { filterTagsWithNonEmptyValues } from 'src/common/helpers/TagsHelper';

import { HorizontalDivider } from '../horizontal-divider/HorizontalDivider';
import { Tag } from '../tag/Tag';

import './TagsBlock.scss';

export interface ITag {
	name: string;
	values: string[];
	maxChars?: number;
}

export interface ITagGroup {
	tags: ITag[];
	title?: string;
}

interface ITagsBlockProps {
	tagGroups: ITagGroup[];
	isThreeColumns?: boolean;
	titlesHeadingLevel?: HeadingLevelRange;
}

const tooltipId = 'tags-block-tooltip';

export const TagsBlock: React.FC<ITagsBlockProps> = ({
	tagGroups,
	isThreeColumns,
	titlesHeadingLevel
}) => {
	const renderTagGroup = ({ tags, title }: ITagGroup, index: number): ReactElement => {
		const tagsWithValues = filterTagsWithNonEmptyValues(tags);

		const needsHorizontalDivider =
			index !== tagGroups.length - 1 &&
			!!tagsWithValues.length &&
			!!filterTagsWithNonEmptyValues(tagGroups[index + 1]?.tags);

		return (
			!!tagsWithValues.length && (
				<div key={`tag-group-${index}`}>
					{!!title?.length && (
						<EvTitle
							titleText={title}
							headingLevel={titlesHeadingLevel ?? 3}
							className="group-title"
						/>
					)}
					<div
						className={classNames('tags-grid', {
							'three-columns': isThreeColumns
						})}
					>
						{tagsWithValues.map((tag) => (
							<Tag
								key={`${tag.name}-${tag.values.join('-')}`}
								values={tag.values}
								label={tag.name}
								maxChars={tag.maxChars}
								tooltipId={tooltipId}
							/>
						))}
					</div>
					{needsHorizontalDivider && <HorizontalDivider />}
				</div>
			)
		);
	};

	return (
		<div className="tags-block">
			{tagGroups.map((group, index) => renderTagGroup(group, index))}
			<EvTooltip id={tooltipId} place="bottom" type="info" />
		</div>
	);
};
